import { render, staticRenderFns } from "./DiseasesList.vue?vue&type=template&id=4f7dd1ce&"
import script from "./DiseasesList.vue?vue&type=script&lang=js&"
export * from "./DiseasesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports